// Pure helpers for the Etsy listing push settings screen (kept out of the
// component file so React fast refresh keeps working).

export type EtsyListingDefaults = {
  shipping: {
    title: string
    origin_country_iso: string
    origin_postal_code: string
    us_first_usd: string
    us_additional_usd: string
    international: 'off' | 'flat'
    intl_first_usd: string
    intl_additional_usd: string
    delivery_min_days: number
    delivery_max_days: number
  }
  processing: {
    source: 'catalog' | 'manual'
    unit: 'days' | 'weeks'
    manual_min: number
    manual_max: number
    ready_to_ship_when_stocked: boolean
  }
  quantity: {
    stocked: 'stock' | 'fixed'
    stocked_fixed: number
    made_to_order: 'max' | 'fixed'
    made_to_order_fixed: number
  }
  declaration: { who_made: 'i_did' | 'someone_else' | 'collective'; when_made: string }
  pricing: { fallback_multiplier: string; bulk_margin_percent: number }
  checklist: {
    production_partner: boolean
    hs_code: boolean
    gpsr: boolean
    ai_disclosure: boolean
  }
}

export type Section = keyof EtsyListingDefaults

/** The fields of `next` that differ from `base` — an org row stays partial. */
export function diffDefaults(
  base: EtsyListingDefaults,
  next: EtsyListingDefaults,
): Partial<Record<Section, Record<string, unknown>>> {
  const out: Partial<Record<Section, Record<string, unknown>>> = {}
  for (const section of Object.keys(next) as Section[]) {
    const changed: Record<string, unknown> = {}
    const b = base[section] as Record<string, unknown>
    const n = next[section] as Record<string, unknown>
    for (const key of Object.keys(n)) {
      if (n[key] !== b[key]) changed[key] = n[key]
    }
    if (Object.keys(changed).length > 0) out[section] = changed
  }
  return out
}

export const clone = (d: EtsyListingDefaults): EtsyListingDefaults => JSON.parse(JSON.stringify(d))
